// removed by extract-text-webpack-plugin
module.exports = {"Aside":"AsideText__Aside__1zgCG","Address":"AsideText__Address__p1w_g","Map":"AsideText__Map__3MjsR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/AsideText/AsideText.css
// module id = 154
// module chunks = 0